import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import {
  CALLABLES,
  type AnnouncementSaveInput,
  type AnnouncementSaveResponse,
  type AnnouncementDeleteInput,
  type AnnouncementsForMeResponse,
  type DismissAnnouncementInput,
  type DismissAnnouncementResponse,
} from '@daaily/shared';

export const callAnnouncementSave = httpsCallable<AnnouncementSaveInput, AnnouncementSaveResponse>(functions, CALLABLES.ANNOUNCEMENT_SAVE);
export const callAnnouncementDelete = httpsCallable<AnnouncementDeleteInput, DismissAnnouncementResponse>(functions, CALLABLES.ANNOUNCEMENT_DELETE);
export const callAnnouncementsForMe = httpsCallable<void, AnnouncementsForMeResponse>(functions, CALLABLES.ANNOUNCEMENTS_FOR_ME);
export const callDismissAnnouncement = httpsCallable<DismissAnnouncementInput, DismissAnnouncementResponse>(functions, CALLABLES.DISMISS_ANNOUNCEMENT);

// Oct 2026: preview of an unsaved draft for one person (+ optional test email to the caller) and image upload.
export interface AnnouncementPreviewResult {
  ok: true; inAudience: boolean; recipients: number;
  rendered: { title: string; blocks: { id: string; body: string; imageUrl: string | null }[] };
  emailSubject: string; emailHtml: string; testSentTo: string | null;
}
export const callAnnouncementPreview = httpsCallable<Record<string, unknown>, AnnouncementPreviewResult>(functions, 'announcementPreview');
export const callAnnouncementImageUpload = httpsCallable<{ base64: string }, { ok: true; url: string }>(functions, 'announcementImageUpload');
